import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import CustomizedDialog from '../Dialog/CustomizedDialog';
import Pagination from '../Common/Pagination';
import { roles } from '../../constants';
import { commonService, siteService } from '../../services';
import { alertActions } from '../../modules/alert';
import { DamdangOfficeSelect, DamdangOrgSelect, DamdangRegionSelect, SiteNameInput, SiteNumInput } from '../Common/InputBox';

class SiteFinder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isAdministratorRole: false,
            opbSearch: {
                damdangOrg: '',
                damdangRegion: '',
                damdangOffice: '',
                siteName: '',
                siteNum: ''
            },
            usedOpbSearch: null,
            orgCodes: [],
            regionCodes: [],
            officeCodes: [],
            totalCount: 1,
            currentPage: 1,
            listCount: 10,
            totalPage: 1,
            startPage: 1,
            endPage: 1,
            siteFinder: false,
            siteList: []
        }

        this.setCommonCodes();
    }

    setCommonCodes = async () => {
        commonService.findOrgCodes()
            .then(response => {
                this.setState({ orgCodes: response.data })
            })
            .catch(this.handleErrors);

        commonService.findRegionCodes()
            .then(response => {
                this.setState({ regionCodes: response.data })
            })
            .catch(this.handleErrors);
    };

    setOfficeCodes = async () => {
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                damdangOffice: (this.state.siteFinder ? this.state.opbSearch.damdangOffice : "")
            },
            officeCodes: [],
            siteFinder: false,
        });
        if (this.state.opbSearch.damdangOrg !== "") {
            commonService.findOfficeCodes(this.state.opbSearch.damdangOrg)
                .then(response => {
                    const officeCodes = response.data.filter(office => office.code !== "");
                    this.setState({ officeCodes: officeCodes })
                })
                .catch(this.handleErrors);
        }
    };

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if (code === 13) { //13 is the enter keycode
            this.buttonSearch.click();
        }
    };

    handleValueChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            opbSearch: {
                ...this.state.opbSearch,
                [name]: value,
            },
            siteFinder: false
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.opbSearch.damdangOrg !== this.state.opbSearch.damdangOrg) {
            this.setOfficeCodes();
        }
    }

    setSiteList = (currentPage) => {
        const { opbSearch, listCount } = this.state;
        const { damdangOrg, damdangRegion, damdangOffice, siteName, siteNum } = opbSearch;
        let formData = new FormData();
        if (damdangOrg !== "") formData.append('damdangOrg', damdangOrg);
        if (damdangRegion !== "") formData.append('damdangRegion', damdangRegion);
        if (damdangOffice !== "") formData.append('damdangOffice', damdangOffice);
        if (siteName !== "") formData.append('siteName', siteName);
        if (siteNum !== "") formData.append('siteNum', siteNum);
        formData.append('listCount', listCount);
        formData.append('currentPage', currentPage);

        siteService.findSiteList(formData)
            .then(response => {
                this.setState({
                    totalCount: response.data.totalCount,
                    currentPage: response.data.currentPage,
                    totalPage: response.data.totalPage,
                    startPage: response.data.startPage,
                    endPage: response.data.endPage,
                    siteList: response.data.siteList,
                    usedOpbSearch: opbSearch
                })
            })
            .catch(this.handleErrors);
    };

    handleSearchButton = () => {
        this.setSiteList(1);
    };

    handleSiteInfo = (siteInfo) => {
        this.setState({
            siteFinder: false,
            open: false
        });
        this.props.handleSiteInfo(siteInfo);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClickOpen = () => {
        const { myInfo, opbSearch } = this.props;
        const { damdangOrg, damdangOffice, damdangRegion, siteName, siteNum } = opbSearch;
        const isAdministratorRole = myInfo.myRole === roles.administratorRole;

        this.setState({
            opbSearch: {
                damdangOrg: damdangOrg && damdangOrg !== "-1" ? damdangOrg : "",
                damdangRegion: damdangRegion && damdangRegion !== "-1" ? damdangRegion : "",
                damdangOffice: damdangOffice && damdangOffice !== "-1" ? damdangOffice : "",
                siteName: siteName || "",
                siteNum: siteNum || "",
            },
            isAdministratorRole,
            siteFinder: true,
            open: true
        }, () => { this.setSiteList(1); });
    };

    handleClose = () => {
        this.setState({
            open: false
        });
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            opbSearch: this.state.usedOpbSearch,
        }, () => { this.setSiteList(currentPage)});
    };

    render() {
        const { opbSearch, orgCodes, regionCodes, officeCodes, totalCount, siteList, isAdministratorRole, open } = this.state;
        const { damdangOrg, damdangRegion, damdangOffice, siteName, siteNum } = opbSearch;
        const colgroupList = ["60%", "20%", "20%"];
        const cellList = ["현장명", "PrjNo", ""];

        return (
            <>
                <button className="button outline-button site-finder-button" onClick={this.handleClickOpen}>
                    <img src="/assets/images/ic-search.svg" className="ic-search" alt="search icon" />
                </button>
                <CustomizedDialog title={'현장찾기'} open={open} handleClose={this.handleClose}>
                    <div className="dialog-content opbmng-siteFinder">
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={3} className="col dialog-search-title">소속</Col>
                            <Col xs={10} sm={10} md={10} lg={9} className="col">
                                <Row className="inner-row">
                                    <Col>
                                        <DamdangOrgSelect orgCodes={orgCodes} damdangOrg={damdangOrg} handleValueChange={this.handleValueChange} disabled={isAdministratorRole} />
                                    </Col>
                                    <Col>
                                        <DamdangOfficeSelect officeCodes={officeCodes} damdangOrg={damdangOrg} damdangOffice={damdangOffice} handleValueChange={this.handleValueChange} disabled={isAdministratorRole} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={3} className="col dialog-search-title">지역</Col>
                            <Col xs={10} sm={10} md={10} lg={9} className="col">
                                <DamdangRegionSelect regionCodes={regionCodes} damdangRegion={damdangRegion} handleValueChange={this.handleValueChange} disabled={isAdministratorRole} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={3} className="col dialog-search-title">현장명</Col>
                            <Col xs={10} sm={10} md={10} lg={9} className="col">
                                <SiteNameInput siteName={siteName} handleValueChange={this.handleValueChange} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2} sm={2} md={2} lg={3} className="col dialog-search-title">PrjNo</Col>
                            <Col xs={10} sm={10} md={10} lg={9} className="col">
                                <SiteNumInput siteNum={siteNum} handleValueChange={this.handleValueChange} />
                            </Col>
                        </Row>
                        <div className="dialog-button-wrapper">
                            <button className="button w100-button primary-button" onClick={this.handleSearchButton} ref={button => this.buttonSearch = button}>검색</button>
                        </div>
                        <Row className="dialog-result-top">
                            <Col className="text-align-left">
                                <span>검색결과: {totalCount}</span>
                            </Col>
                            <Col className="text-align-right">
                                <button className="button w98-button white-button" name="초기화" onClick={this.handleClickOpen}><img src="/assets/images/ic-refresh.svg" alt="초기화" className="ic-refresh" />초기화</button>
                            </Col>
                        </Row>
                        <table className="w100per">
                            <colgroup>
                                {colgroupList.map((col, index) => {
                                    return <col key={index} width={col} />;
                                })}
                            </colgroup>
                            <thead className="table-head">
                                <tr>
                                    {cellList.map((cell, index) => {
                                        return <th key={index}>{cell}</th>
                                    })}
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {siteList && siteList.map((siteInfo, i) =>
                                    <SiteItem key={i} siteInfo={siteInfo} handleSiteInfo={this.handleSiteInfo} />)
                                }
                                {siteList.length === 0 &&
                                    <tr>
                                        <td className="text-align-center" colSpan={cellList.length}>
                                            <div className="" style={{ margin: '20px auto' }}>
                                                <img src={"/assets/images/ic-no-result.svg"} alt="결과없음" /><br />
                                                검색결과가 없습니다.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <Pagination list={this.state} getCurrentPage={this.getCurrentPage} />
                    </div>
                </CustomizedDialog>
            </>
        )
    }
}

function SiteItem({ siteInfo, handleSiteInfo }) {
    const { siteName, siteNum } = siteInfo;

    return (
        <tr>
            <td className="text-align-left padding-l10">{siteName}</td>
            <td className="text-align-center">{siteNum}</td>
            <td><button className="button w40-button" onClick={() => { handleSiteInfo(siteInfo) }}>선택</button></td>
        </tr>
    );
}


function mapState(state) {
    const { userinfo } = state;
    const myInfo = userinfo.item;
    return { myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(SiteFinder);